"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _toArray = _interopRequireDefault(require("rc-util/lib/Children/toArray"));
var _Avatar = _interopRequireDefault(require("./Avatar"));
var _Popover = _interopRequireDefault(require("../Popover"));
var _SizeContext = require("./SizeContext");
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledAvatar = require("./StyledAvatar");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var AvatarGroup = function AvatarGroup(props) {
  var prefixCls = props.prefixCls,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    maxCount = props.maxCount,
    size = props.size,
    children = props.children,
    _props$maxPopoverPlac = props.maxPopoverPlacement,
    maxPopoverPlacement = _props$maxPopoverPlac === void 0 ? 'top' : _props$maxPopoverPlac,
    _props$maxPopoverTrig = props.maxPopoverTrigger,
    maxPopoverTrigger = _props$maxPopoverTrig === void 0 ? 'hover' : _props$maxPopoverTrig,
    showPopover = props.showPopover;
  var cls = (0, _classnames.default)(prefixCls, className);
  var childrenWithProps = (0, _toArray.default)(children).map(function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, {
      key: "avatar-key-".concat(index),
      inGroup: true
    });
  });
  var numOfChildren = childrenWithProps.length;
  if (maxCount && maxCount < numOfChildren) {
    var childrenShow = childrenWithProps.slice(0, maxCount);
    var childrenHidden = childrenWithProps.slice(maxCount, numOfChildren);
    var childrenWithInPopover = (0, _toArray.default)(childrenHidden).map(function (child, index) {
      if (index >= 1) {
        return /*#__PURE__*/React.cloneElement(child, {
          inPopover: true,
          inGroup: false
        });
      } else {
        return /*#__PURE__*/React.cloneElement(child, {
          inGroup: false
        });
      }
    });
    childrenShow.push(/*#__PURE__*/React.createElement(_Popover.default, {
      key: "ykb-ui-avatar-key",
      content: childrenWithInPopover,
      trigger: showPopover ? maxPopoverTrigger : '',
      placement: maxPopoverPlacement,
      prefixCls: "".concat(prefixCls, "-popover"),
      overlayClassName: "ykb-ui-avatar-popover-overlay"
    }, /*#__PURE__*/React.createElement(_Avatar.default, {
      style: {
        cursor: showPopover ? 'pointer' : 'default'
      },
      inGroup: true
    }, "+".concat(numOfChildren - maxCount))));
    return /*#__PURE__*/React.createElement(_SizeContext.SizeContextProvider, {
      size: size
    }, /*#__PURE__*/React.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
      return /*#__PURE__*/React.createElement(_StyledAvatar.StyledAvatarGroup, {
        className: cls,
        style: props.style,
        theme: theme
      }, childrenShow);
    }));
  }
  return /*#__PURE__*/React.createElement(_SizeContext.SizeContextProvider, {
    size: size
  }, /*#__PURE__*/React.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/React.createElement(_StyledAvatar.StyledAvatarGroup, {
      className: cls,
      style: props.style,
      theme: theme
    }, childrenWithProps);
  }));
};
AvatarGroup.defaultProps = {
  prefixCls: 'ykb-ui-avatar-group',
  showPopover: false,
  maxPopoverPlacement: 'top',
  maxPopoverTrigger: 'hover',
  size: 'default',
  maxCount: undefined
};
var _default = exports.default = AvatarGroup;